import type { HttpClient } from '../core/http.js';
import type { RequestOptions } from '../types/common.js';

/**
 * The one API-token route an API token may call.
 *
 * @remarks
 * This class looks incomplete on purpose. `ApiTokenGuard` is fail-closed: a
 * route that declares no `@ApiScopes()` rejects API tokens outright with
 * `403 "This endpoint is not available to API tokens"`. Listing, creating,
 * regenerating and status changes are all dashboard-session routes, so
 * modelling them here would only ship methods that can never succeed.
 *
 * `DELETE /api-tokens/:id` is the documented exception — it carries
 * `@AllowAnyApiToken()` so an integration can revoke its own token when the
 * merchant disconnects. Ownership is still enforced server-side.
 *
 * Manage tokens at https://app.gpmpay.com/api-tokens.
 */
export class ApiTokensResource {
  constructor(private readonly http: HttpClient) {}

  /**
   * Permanently delete a token. Any valid token may call this; the backend
   * still requires the token being deleted to belong to the caller.
   */
  remove(id: string, options: RequestOptions = {}): Promise<unknown> {
    return this.http.request<unknown>(
      'DELETE',
      `/api-tokens/${encodeURIComponent(id)}`,
      options,
    );
  }
}
